import React, { useCallback } from 'react';

import { QStack } from '@captivateiq/quotient';

import { useAIShellContext } from '@captivateiq/assistant/AIShellContext';

type SamplePromptCardProps = {
  prompt: string;
};
export const SamplePromptCard = ({ prompt }: SamplePromptCardProps) => {
  const { openChatAndSend } = useAIShellContext();

  const startChatWithPrompt = useCallback(async () => {
    try {
      await openChatAndSend(prompt);
    } catch (error) {
      // Error is handled in AIShellContext and displayed in ChatView
    }
  }, [openChatAndSend, prompt]);

  return (
    <QStack
      direction="row"
      spacing="10px"
      sx={{
        alignItems: 'center',
        backgroundColor: 'white',
        border: '1px solid',
        borderColor: 'grey.300',
        borderRadius: '8px',
        cursor: 'pointer',
        justifyContent: 'stretch',
        padding: '12px',
        '&:hover': {
          backgroundColor: 'grey.100',
        },
      }}
      onClick={startChatWithPrompt}
    >
      {prompt}
    </QStack>
  );
};
